/* eslint-disable no-unused-vars, eqeqeq, react-hooks/exhaustive-deps, jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/no-static-element-interactions, jsx-a11y/no-autofocus, react/jsx-no-target-blank, react/jsx-pascal-case, jsx-a11y/alt-text, import/no-anonymous-default-export, no-lone-blocks */
import axios from "axios"

export default () => {
  const api = axios.create({
    baseURL: process.env.GATSBY_API_URL,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token") || null,
    },
  })

  return api
}
